import { Navigate } from "react-router-dom";
import React, {useContext} from "react";
import { AuthContext } from "../context/authContext.js";
import LoadingPage from "../Error/LoadingPage/LoadingPage.jsx";

export default function ProtectedRoute({ children, allowedRoles }) {
  const { user , loading} = useContext(AuthContext);
    if (loading) {
    return <LoadingPage/>; // or spinner component
  }

  console.log(user)
  if (!user) {
    return <Navigate to="/login" replace />;
  }

  if (!allowedRoles.includes(user.role)) {
    return <Navigate to="/unauthorized" replace />;
  }

  return children;
}